import CoverpageView from "./CoverpageView";

export default CoverpageView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/CoverpageView/index.js